import React from 'react';
import {
	summary,
	way,
	fee,
	provide,
	provideTable,
	refundPolicy,
	schedule,
	mobileFee,
	mobileDeposit,
} from './data';
import {BreadCrumb, CardSection} from '../../../Components/Template';
import {Container} from '../../../Components/Atom';

const Summary = () => {
	return (
		<Container>
			<BreadCrumb depths={['HOME', '대회안내', '대회요강']} />
			<CardSection {...summary} />
			<CardSection {...way} />
			<CardSection {...fee} />
			<CardSection {...provide} />
			<CardSection {...provideTable} />
			<CardSection {...mobileFee} />
			<CardSection {...mobileDeposit} />
			<CardSection {...refundPolicy} />
			<CardSection {...schedule} />
		</Container>
	);
};

export default Summary;
